"use client";

import { MotionConfig } from "framer-motion";

/**
 * App-wide Framer config. `reducedMotion="user"` makes every Framer animation
 * respect the OS "reduce motion" setting (transforms/opacity are skipped to
 * their resting state) — the JS counterpart to the global
 * `prefers-reduced-motion` CSS rule in `globals.css`. Mounted once in the app
 * providers so individual motion components never need their own guard.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
